import React from 'react';
import useAppStore from '../../../store';

function AuditLogTab() {
  const auditLog = useAppStore((state) => state.auditLog);

  return (
    <div className="settings-tab">
      <p className="settings-note">
        Mutations from this session (invites, role changes, keys, webhooks) are
        recorded here automatically (T10.3). The server-side trail will merge in
        at backend integration.
      </p>
      <div className="portal-table-wrap">
        <table className="portal-table">
          <thead>
            <tr>
              <th scope="col">When</th>
              <th scope="col">Actor</th>
              <th scope="col">Action</th>
              <th scope="col">Detail</th>
            </tr>
          </thead>
          <tbody>
            {auditLog.map((entry) => (
              <tr key={entry.id}>
                <td className="settings-mono">{entry.at}</td>
                <td>{entry.actor}</td>
                <td><code className="settings-action">{entry.action}</code></td>
                <td>{entry.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!auditLog.length && <p className="settings-note">No audit entries yet.</p>}
    </div>
  );
}

export default AuditLogTab;
